import React from "react";
import Section2_title from "./title";
import Section2_menu from "./menu";

function Section2_index(){
    return(
        <div id="section2">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Section2_title />
                        <Section2_menu />
                        {/* <Show_more /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

function Show_more(){
    return(
        <div className="show-more">
            <a href="#!">نمایش همه</a>
        </div>
    );
}

export default Section2_index;